import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

export const setColorTheme = isOSOnDarkMode => {
  // Default OSDEPYM: "violet" para quien no eligió tema aún (antes era 'auto').
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'violet';
  const { classList } = document.body;
  classList.remove('dark', 'violet');

  if (selectedColorScheme === 'violet') {
    // Tema "Violeta" (OSDEPYM): contenido claro + sidebar violeta (ver _next-colors.scss).
    classList.add('violet');
    document.documentElement.style.setProperty('color-scheme', 'light');
  } else if (
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
  ) {
    classList.add('dark');
    document.documentElement.style.setProperty('color-scheme', 'dark');
  } else {
    document.documentElement.style.setProperty('color-scheme', 'light');
  }
};
